module.exports = __webpack_public_path__ + "img/parallel.e9516a6a.svg";